import ConsoleApi from "apps/console/enums/consoleApi";
import { usePostApiData } from "shared/datalayer";
import { useCopies } from "shared/hooks/useCopies";
import { successToast } from "shared/utils/toastNotification";
import { ApiConsoleUserSetPassword } from "shared/types/ApiConsoleUserSetPassword";

export function useAcceptUserInvitation() {
  const copies = useCopies();
  return usePostApiData<boolean, ApiConsoleUserSetPassword>(ConsoleApi.ACCEPT_USER_INVITATION, {
    clientOptions: { trimAndRemoveNull: false },
    onSuccess: () => successToast(copies.get("user.invitation.accepted"))
  });
}

export function useResetPassword() {
  const copies = useCopies();
  return usePostApiData<boolean, ApiConsoleUserSetPassword>(ConsoleApi.RESET_PASSWORD, {
    clientOptions: { trimAndRemoveNull: false },
    onSuccess: () => successToast(copies.get("password.reset.success"))
  });
}
